import $http from '@/libs/axios'

export default class InstagramReplyApi {
  static async find(mediaId: any) {
    return (await $http.get(`instagram/reply/get/${mediaId}`)).data
  }

  static async findStory(mediaId: any) {
    return (await $http.get(`instagram/story-reply/get/${mediaId}`)).data
  }

  static async deleteReply(id: string) {
    return (await $http.delete(`instagram/reply/delete/${id}`)).data
  }

  static async deleteStoryReply(id: string) {
    return (await $http.delete(`instagram/story-reply/delete/${id}`)).data
  }

  static async addReply(accountId: any, data: any) {
    return (await $http.post(`instagram/reply/add/${accountId}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  static async addStoryReply(accountId: any, data: any) {
    return (await $http.post(`instagram/story-reply/add/${accountId}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  static async dependencies() {
    return (await $http.get('instagram/reply/dependencies')).data
  }

  static async templatesList() {
    return (await $http.get('instagram/reply/templates')).data
  }

  static async findTemplate(id: any) {
    return (await $http.get(`instagram/reply/templates/${id}`)).data
  }

  static async addTemplate(data: any) {
    return (await $http.post('instagram/reply/templates', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  static async deleteReplyTemplate(id: string) {
    return (await $http.delete(`instagram/reply/templates/${id}`)).data
  }

  static async enableDisableComment(accountId: any, data: any) {
    return (await $http.post(`instagram/reply/process-comment/${accountId}`, data)).data
  }

  static async changeReplyStatus(accountId: any, replyId: any) {
    return (await $http.get(`instagram/reply/change-status/${accountId}/${replyId}`)).data
  }
}
